<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{'fleet_reports.daily_hourly_charger_usage_data' | translate}}
			</h4>
		</div>
	</div>

	<div class="row mb-4">
		<!-- Monthly or Quarterly drop-down -->
		<div class="col-sm-6 col-md-3 d-inline-flex">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="periodTypes" bindLabel="label" bindValue="id" placeholder="{{'perf_analytic.period' | translate}}" name="period" [(ngModel)]="selectedPeriodType" (ngModelChange)="changePeriodType()" [clearable]="false">
			</ng-select>
		</div>

		<!-- date range filter -->
		<div class="col-xl-7" *ngIf="selectedPeriodType == 'daily'">
			<div class="row">
				<div class="col-xl-6 col-md-6">
					<div class="input-group">
						<div class="input-group-prepend">
							<span class="input-group-text">{{'g.start_date' | translate}}</span>
						</div>
						<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('fromDate', $event)" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="minDate">
						<div class="input-group-append pointer" (click)="d1.toggle()">
							<span class="input-group-text"><i class="fa fa-calendar"></i></span>
						</div>
					</div>
				</div>

				<div class="col-xl-6 col-md-6">
					<div class="input-group">
						<div class="input-group-prepend">
							<span class="input-group-text">{{'g.end_date' | translate}}</span>
						</div>
						<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp2" (ngModelChange)="changeDate('toDate', $event)" [(ngModel)]="toDate" bsDatepicker #d2="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [minDate]="fromDate">
						<div class="input-group-append pointer" (click)="d2.toggle()">
							<span class="input-group-text"><i class="fa fa-calendar"></i></span>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- one day filter -->
		<div class="col-xl-7" *ngIf="selectedPeriodType == 'hourly'">
			<div class="col-xl-6 col-md-6">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text">{{'g.date' | translate}}</span>
					</div>
					<input type="text" class="form-control" placeholder="mm/dd/yyyy" name="dp1" (ngModelChange)="changeDate('fromDate', $event)" [(ngModel)]="fromDate" bsDatepicker #d1="bsDatepicker" [bsConfig]="{containerClass: 'theme-dark-blue'}" [maxDate]="toDate" [minDate]="minDate">
					<div class="input-group-append pointer" (click)="d1.toggle()">
						<span class="input-group-text"><i class="fa fa-calendar"></i></span>
					</div>
				</div>
			</div>
		</div>

		<div class="d-inline-flex ml-auto">
			<button  class="btn fa fa-print fa-lg" printTitle="{{'fleet_reports.daily_hourly_charger_usage_data' | translate}}" [useExistingCss]="true" printSectionId="daily_hourly_charger_usage_data" ngxPrint title="{{'g.print' | translate}}"></button>
			<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportDataToCsv()"></button>
		</div>
	</div>

	<!-- charts toggle -->
	<div class="row mb-4">
		<div class="col-sm-6 col-md-3 d-inline-flex">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="chartsList" bindLabel="label" bindValue="id" placeholder="{{'g.chart' | translate}}" name="chart" [(ngModel)]="selectedCharts" [clearable]="false">
			</ng-select>
		</div>
	</div>

	<!-- chart -->
	<div id="daily_hourly_charger_usage_data">
		<app-print-filters title="fleet_reports.daily_hourly_charger_usage_data" [filters]="printFilters"></app-print-filters>
		<div class="row" *ngIf="['charge_hours', 'all'].includes(selectedCharts)">
			<sct-charts
				id="charge_hours"
				title="{{'fleet_reports.charge_hours' | translate}}"
				[data]="chartsData.charge_hours"
				[columnNames]="monthlyChartObject.columnNames"
				[options]="monthlyChartObject.config"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="['charge_ah', 'all'].includes(selectedCharts)">
			<sct-charts
				id="charge_ah"
				title="{{'fleet_reports.charge_ah' | translate}}"
				[data]="chartsData.charge_ah"
				[columnNames]="monthlyChartObject.columnNames"
				[options]="monthlyChartObject.config"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="['charge_kwh', 'all'].includes(selectedCharts)">
			<sct-charts
				id="charge_kwh"
				title="{{'fleet_reports.charge_kwh' | translate}}"
				[data]="chartsData.charge_kwh"
				[columnNames]="monthlyChartObject.columnNames"
				[options]="monthlyChartObject.config"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
	</div>
</div>
